export default __webpack_public_path__ + "static/Statistics 1-45924cf34a0ffe3a33f66c8882f20132.svg";